// src/utils/supabase-batch.js
import supabase from "./supabase";

/** 汎用チャンク */
export function chunk(arr, size = 200) {
  if (!Array.isArray(arr) || arr.length === 0) return [];
  const n = Math.max(1, size);
  return Array.from({ length: Math.ceil(arr.length / n) }, (_, i) =>
    arr.slice(i * n, (i + 1) * n)
  );
}

/**
 * .in(...) を size ごとに分割して連結
 * @param {object} opts
 * @param {string} opts.table テーブル名
 * @param {string} opts.column .inするカラム名
 * @param {Array<string|number>} opts.values 値配列
 * @param {string} [opts.select="*"] select 句。リレーションも可（例: "journal:journal_id(name_english)"）
 * @param {number} [opts.chunkSize=200] 1バッチの最大ID数
 * @param {object} [opts.order] { column, ascending, referencedTable }
 * @returns {Promise<Array<any>>}
 */
export async function selectInBatched({
  table,
  column,
  values,
  select = "*",
  chunkSize = 200,
  order,
}) {
  const uniq = Array.from(
    new Set((Array.isArray(values) ? values : []).filter((v) => v != null))
  );
  if (uniq.length === 0) return [];

  const parts = chunk(uniq, chunkSize);
  const all = [];

  for (const part of parts) {
    let q = supabase.from(table).select(select).in(column, part);
    if (order?.column) {
      if (order.referencedTable) {
        q = q.order(order.column, {
          ascending: order.ascending ?? true,
          foreignTable: order.referencedTable,
        });
      } else {
        q = q.order(order.column, { ascending: order.ascending ?? true });
      }
    }
    const { data, error } = await q;
    if (error) throw error;
    if (data?.length) all.push(...data);
  }
  return all;
}

/** journals の id → 表示名マップ（name_english / name_original / slug） */
export async function getJournalsMapByIds(ids, { chunkSize = 200 } = {}) {
  const rows = await selectInBatched({
    table: "journals",
    column: "id",
    values: ids,
    select: "id, name_english, name_original, slug",
    chunkSize,
  });
  const m = new Map();
  for (const j of rows) {
    m.set(
      String(j.id),
      j.name_english || j.name_original || j.slug || ""
    );
  }
  return m;
}
